const getDefaultColor = () => {
  return '#575756'
}
export default getDefaultColor
